module.exports = __webpack_public_path__ + "img/Shift_Schedule_out.71c94226.jpg";